import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Fade } from "react-reveal";
import { FaDownload } from "react-icons/fa";
import "./ContactComponent.css";

function Resume(props) {
  const theme = props.theme;

  return (
    <div className="contact-main">
      <Header theme={theme} setTheme={props.setTheme} />

      <div className="basic-contact">
        <Fade bottom duration={1000} distance="40px">
          <div className="resume-download">
            <a
              href="/zeyad_tharwat_resume.pdf"
              download
              className="download-btn"
            >
              <FaDownload className="download-icon" />
              Download CV
            </a>
          </div>
          <iframe
            src="/zeyad_tharwat_resume.pdf#toolbar=0&navpanes=0&scrollbar=0"
            title="Resume PDF"
            width="100%"
            height="800px"
            frameBorder="0"
            
            style={{
              border: "none",
              outline: "none",
              boxShadow: "none",
              borderRadius: "12px",
            }}
                    />
        </Fade>
      </div>

      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Resume;
